/** @jsxRuntime classic */
/** @jsx jsx */
import ExhibitorPreviewPage from '@bottlebooks/gatsby-theme-event/src/components/Preview/ExhibitorPreviewPage';
import { jsx } from 'theme-ui';
import PreviewLinkProvider from '../../../PreviewLinkProvider';

export default function ExhibitorPreview(props) {
  const { eventId, exhibitorId } = props.params;
  const event = {
    eventId,
    exhibitorId,
  };
  return (
    <PreviewLinkProvider eventId={eventId}>
      <ExhibitorPreviewPage
        event={event}
        exhibitorId={exhibitorId}
        locale={'en_US'}
        path={`/p/events/:eventId/exhibitors/:exhibitorId`}
      />
    </PreviewLinkProvider>
  );
}
